/**
 * @fileoverview Module for `src/letter-kits/letterKitTypes.js`.
 */

import PropTypes from 'prop-types';

/**
 * Constant identifying letter kit bundle requests.
 *
 * @type {string}
 */
const letterKitType = 'LETTERKIT';

/**
 * Shared PropTypes shape for letter kit summary rows.
 */
const letterKitPropType = PropTypes.shape({
  createdAt: PropTypes.string.isRequired,
  'districts.displayName': PropTypes.string.isRequired,
  status: PropTypes.string.isRequired,
});

export { letterKitPropType, letterKitType };
